export default (function (_ref) {
  var request = _ref.request;
  return {
    breedAdd: function breedAdd(data) {
      return request({
        url: '/cms/breed/add',
        method: 'post',
        data: data
      });
    },
    breedModify: function breedModify(data) {
      return request({
        url: "/cms/breed/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedDel: function breedDel(id) {
      return request({
        url: "/cms/breed/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedQuery: function breedQuery(data) {
      return request({
        url: '/cms/breed',
        method: 'get',
        params: data
      });
    },
    breedDetail: function breedDetail(id) {
      return request({
        url: "/cms/breed/".concat(id),
        method: 'get'
      });
    }
  };
});